import cn from 'classnames';
import { FieldRequiredMark, Text } from '@/shared/ui/core';
import styles from './required-data-note.module.scss';


type ComponentProps = {
    className?: string;
}


export function RequiredDataNote ({ className }: ComponentProps) {
    return (
        <div className={ cn(styles.root, className) }>
            <FieldRequiredMark/>

            <Text>
                &nbsp;Required information
            </Text>
        </div>
    );
}
